import { totalPurchasesAPI } from "@src/api/payments";
import { getCurrentMonthDays } from "@src/utils/current-month";
import { useQuery } from "@tanstack/react-query";
import useAuthService from "./useAuthService";
import { totalPurchasesCurrentMonth } from "@src/api/purchases";

type ServiceOperators = {
  totalPurchasesThisMonth: any;
};

export const usePaymentsService = (): Readonly<ServiceOperators> => {
  const { currentUser } = useAuthService();

  const { data } = useQuery({
    queryKey: ["current-month-purchases"],
    queryFn: async () => {
      const purchaseRes = await totalPurchasesCurrentMonth();

      return purchaseRes || {};
    },
    enabled: !!currentUser?.id,
  });

  return {
    totalPurchasesThisMonth: data || {},
  };
};
